import React from 'react';
import { Box, Typography } from '@ublend-npm/aulaui-core';
import StudentRow from './StudentRow';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  onToggleStudent: (studentId: string) => void;
  selectedIds: string[];
  students: ExtensionStudent[];
  styles: ManageExtensionStyles;
};

const CohortStudentsList = ({
  onToggleStudent,
  selectedIds,
  students,
  styles,
}: Props) => (
  <>
    <Typography component="h3" sx={styles.cohortTitle}>
      Main Cohort ({students.length})
    </Typography>
    <Box component="ul" sx={styles.studentList}>
      {students.map((student) => (
        <StudentRow
          key={student.id}
          canAdd
          isSelected={selectedIds.includes(student.id)}
          onToggle={onToggleStudent}
          student={student}
          styles={styles}
        />
      ))}
    </Box>
  </>
);

export default CohortStudentsList;
